import { useSelector } from 'react-redux';
import useMedicineStore from '../zustandstores/medicinecart.store';
import { CART_TABS } from '../utils/constants';
import { create } from 'zustand';

const useCartStore = create((set) => ({
    tab: CART_TABS.TESTS,
    setTab: (tabName) => set(state => ({...state, tab: tabName})),
}));

const useCart = () => {
    const {cart: testCart, orderInfo: testsOrderInfo} = useSelector(state => state.cart);
    const {cart: medCart, orderInfo: medsOrderInfo} = useMedicineStore();
    const {tab, setTab} = useCartStore();

    const currentCart = tab === CART_TABS.TESTS ? testCart : medCart;
    const currentOrderInfo = tab === CART_TABS.TESTS ? testsOrderInfo : medsOrderInfo;

    return { cart: currentCart, tab, setTab, orderInfo: currentOrderInfo };
};

export default useCart;